import type { InjectionKey } from 'vue';

export const MenuGroupItemsCounterFn = Symbol('MenuGroupItemsCounter') as InjectionKey<() => void>;
